import { Pipe, PipeTransform, Injector } from '@angular/core';

import { ValueTrackEvent } from '../../track-handlers';
import { TrackUtil } from '../../track-util';
import { TRACK_FN } from '../../utils';

@Pipe({
  name: 'cignaTrackValue',
})
export class TrackValuePipe<TValue> implements PipeTransform {
  constructor(private _util: TrackUtil, private _injector: Injector) {}

  transform(value: TValue, eventName: string, ...extra: unknown[]): TValue {
    this._util[TRACK_FN]<ValueTrackEvent<TValue>>(
      { value, injector: this._injector },
      [eventName, ...extra],
    );

    return value;
  }
}
